import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';
import { parseVykupWizardSearch } from '@/modules/ojeta-vozidla/wizard-helpers';

const VykupWizard = lazy(() =>
  import('@/modules/ojeta-vozidla/VykupWizard').then((m) => ({ default: m.VykupWizard })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/ojeta-vozidla/vykup/wizard',
  component: () => (
    <Suspense fallback={null}>
      <VykupWizard />
    </Suspense>
  ),
  validateSearch: parseVykupWizardSearch,
});
